$(document).ready(function () {
  var $button = $('.sticky-button-small-device');
  var $footer = $('.shopify-section-group-footer-group');

  function updateButtonOnScroll() {
    var windowWidth = $(window).width();

    if (windowWidth >= 749) {
      $button.removeClass('hidden');
      return;
    }

    if ($footer.length) {
      // var scrollTop = $(window).scrollTop();
      // var windowHeight = $(window).height();
      // var footerTop = $footer.offset().top;
      // var footerVisible = scrollTop + windowHeight > footerTop;

      // if (footerVisible) {
      //   $button.addClass('hidden');
      // } else {
      //   $button.removeClass('hidden');
      // }
    } else {
      // No footer found — always show the button
      $button.removeClass('hidden');
    }
  }

  // Run on scroll and resize
  $(window).on('scroll resize', updateButtonOnScroll);

  // Initial check
  updateButtonOnScroll();
});